export const ACTIVE_PLAN_PERIOD = {
	PROMO: 'PROMO',
	DISCOUNTED: 'DISCOUNTED',
	NORMAL: 'NORMAL',
};

export const CANCELLATION_EFFECTIVE = {
	END_OF_BILLING_PERIOD: 'END_OF_BILLING_PERIOD',
	NOT_IN_THIS_PHASE: 'NOT_IN_THIS_PHASE',
};

export const DPG_DEAL_PLAN_ID = 'Basis_3M4EuroDiscount_Evergreen';
